import { render, staticRenderFns } from "./TablaGeneralSensores.vue?vue&type=template&id=57ab6866&scoped=true&"
import script from "./TablaGeneralSensores.vue?vue&type=script&lang=js&"
export * from "./TablaGeneralSensores.vue?vue&type=script&lang=js&"
import style0 from "./TablaGeneralSensores.vue?vue&type=style&index=0&id=57ab6866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ab6866",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VDatePicker,VMenu,VProgressCircular,VSimpleTable,VTextField})
